import { render } from "./two-factor-authentication.vue?vue&type=template&id=481412a0&ts=true"
import script from "./two-factor-authentication.vue?vue&type=script&lang=ts"
export * from "./two-factor-authentication.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__